<ng-container *ngIf="product">
  <div class="card shadow-sm animate__animated animate__fadeIn">
    <div class="remove-container">
      <button class="btn btn-outline-dark" (click)="removeItem()">
        <i class="bi bi-x"></i>
      </button>
    </div>
    <!-- Product image-->
    <div
      class="card-img-top"
      [ngStyle]="{
        'background-image': 'url(' + product.image + ' )'
      }"
      routerLink="/pdp/{{ product.id }}"
    ></div>
    <!-- Product details-->
    <div class="card-body p-2">
      <div class="text-center">
        <!-- Product name-->
        <h5 class="fw-bolder">
          {{ product.title }}
        </h5>
        <div>
          {{ product.description }}
        </div>
        <!-- Product price-->
        <i><strong>Price:</strong></i> {{ product.price | currency }}
        <!-- Product quantity-->
        <div>
          <i><strong>Quantity:</strong></i>
          {{ product.quantity }}
        </div>
      </div>
    </div>
  </div>
</ng-container>
